import React, { useState } from "react";
import { format, subDays } from "date-fns";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import * as XLSX from "xlsx";
import * as Fa from "react-icons/fa";

const url = "CouponDisbursement/";
const Getdownload_url = `${url}DownloadCouponReport?`;

const CouponReporttoExcel = () => {
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);

    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [selectedtypeWise, setSelectedTypeWise] = useState("Castrol");
    const [loading, setLoading] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const typeWise = [
        { label: "Castrol", value: "Castrol" },
        { label: "Bosch", value: "Bosch" },
    ];

    const handleDownloadReport = async () => {
        const dayDiff = Math.ceil(
            (new Date(toDate).getTime() - new Date(fromDate).getTime()) /
        (1000 * 60 * 60 * 24)
        );

        if (dayDiff > 90) {
            toast.warn("Please select a date range up to 90 days only.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
            });
            return;
        }
        const fDate = format(fromDate, "dd-MM-yyyy");
        const tDate = format(toDate, "dd-MM-yyyy");

        try {
            setLoading(true);
            const apiURL = `${Getdownload_url}FromDate=${fDate}&ToDate=${tDate}&ReportType=${selectedtypeWise}&CompId=${auth.CompId}`;

            const response = await Axios.get(apiURL);
            const data = response.data.Data;

            if (data && data.length > 0) {
                const fileName = `CouponReport_${fDate}_to_${tDate}.xlsx`;
                const worksheet = XLSX.utils.json_to_sheet(data);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "CouponReport");
                XLSX.writeFile(workbook, fileName);
            } else {
                setSuccessMessage("No data found.");
                setShowSuccessDialog(true);
            }
        } catch (error) {
            console.error("Excel download error:", error);
            toast.error("Failed to download the report", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };
    // const handleDateChange = (selectedDate, setter) => {
    //     if (selectedDate < minDate || selectedDate > maxDate) {
    //         toast.warn("Please select a date within the last 3 months.", {
    //             position: toast.POSITION.TOP_CENTER,
    //             autoClose: 3000,
    //         });
    //         return;
    //     }
    //     setter(selectedDate);
    // };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Coupon Report To Excel</h3>
                    </div>
                </div>

                <section className="sales-box">
                    <form>
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar
                                    onChange={(e) => setFromDate(e.value)}
                                    showIcon
                                    value={fromDate}
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar
                                    value={toDate}
                                    onChange={(e) => setToDate(e.value)}
                                    showIcon
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <label className="form-label">Report Type</label>
                                <Dropdown
                                    value={selectedtypeWise}
                                    options={typeWise}
                                    onChange={(e) => setSelectedTypeWise(e.value)}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Select Report Type"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleDownloadReport}
                                >
                                    {loading ? "Loading..." : "Download Report"}
                                    <Fa.FaDownload className="ms-2" />
                                </button>
                            </div>
                        </div>
                    </form>
                </section>
            </div>

            <Dialog
                header="No Data Found"
                visible={showSuccessDialog}
                modal
                onHide={() => setShowSuccessDialog(false)}
                style={{ width: "30vw" }}
                closable={false}
                footer={
                    <div className="text-end">
                        <button
                            className="btn btn-primary"
                            onClick={() => setShowSuccessDialog(false)}
                        >
              OK
                        </button>
                    </div>
                }
            >
                <p className="m-0 text-center">{successMessage}</p>
            </Dialog>
        </>
    );
};

export default CouponReporttoExcel;
